import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import updateDocument from "astrid-firestore/src/helpers/updateDocument";
import useCollectionDataOptions from "astrid-firestore/src/hooks/useCollectionDataOptions";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function UserNarratorSettings({ user }) {
	const { t } = useTranslation();

	const [organizationOptions] = useCollectionDataOptions(db.collection("organizations"));

	const { readerData } = user;

	const form = useSimpleForm({
		defaultValues: {
			reader: !!user.permissions?.reader,
			searchable: readerData?.searchable || false,
			selfRecorder: readerData?.selfRecorder || false,
			visibleContactDetails: user.visibleContactDetails || false,
			organizationIds: user.organizationIds || [],
		},

		onSubmit: ({ reader, searchable, selfRecorder, visibleContactDetails, organizationIds }) => {
			return updateDocument(user.ref, {
				"permissions.reader": reader ? ["any", "allProducers", "allPublishers"] : false,
				"readerData.searchable": searchable,
				"readerData.selfRecorder": selfRecorder,
				organizationIds,
				visibleContactDetails,
			});
		},
	});

	const { watch, error, formState, onSubmit } = form;

	const { reader } = watch();

	return (
		<>
			<Header as="h3">{t("narratorSettings", "Narrator settings")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Group>
							<Form.Checkbox
								name="reader"
								checked={reader}
								slider
								label={t("narrator", "Narrator")}
								rules={{ required: false }}
							/>
							{reader && (
								<>
									<Form.Checkbox
										name="searchable"
										label={t("searchable")}
										shouldUnregister={false}
										rules={{ required: false }}
									/>
									<Form.Checkbox
										name="visibleContactDetails"
										label={t("visibleDetails")}
										shouldUnregister={false}
										rules={{ required: false }}
									/>
									<Form.Checkbox
										name="selfRecorder"
										label={t("technicianForOwnRec")}
										shouldUnregister={false}
										rules={{ required: false }}
									/>
								</>
							)}
						</Form.Group>

						{reader && (
							<Form.Select
								name="organizationIds"
								label={t("organizations", "Organizations")}
								shouldUnregister={false}
								rules={{ required: false }}
								multiple
								search
								options={organizationOptions.filter((option) => option.value !== option.text)}
							/>
						)}
					</Form>

					{error && <ErrorMessage error={error} />}
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
